import {
  AudioLines,
  Check,
  Download,
  MessageSquareText,
  Moon,
  RefreshCw,
  Sun,
  Video,
  X,
} from "lucide-react";
import classes from "../../_css/UI.module.css";

export function CustomButtonLight({
  text,
  onClick,
  fontSize = "14px",
  disabled = false,
  width = "fit-content",
  padding = "4px 18px",
  icon = null,
}) {
  return (
    <button
      style={{
        fontSize,
        width,
        padding,
      }}
      className={classes["custom-btn-light"]}
      onClick={onClick}
      disabled={disabled}
    >
      {icon === "text" && (
        <i className={classes["icon"]}>
          <MessageSquareText size={16} />
        </i>
      )}
      {icon === "voice" && (
        <i className={classes["icon"]}>
          <AudioLines size={16} />
        </i>
      )}
      {icon === "video" && (
        <i className={classes["icon"]}>
          <Video size={16} />
        </i>
      )}
      {text}
    </button>
  );
}

export function CustomButtonOutlineLight({
  text,
  onClick,
  fontSize = "14px",
  disabled = false,
  width = "fit-content",
  padding = "4px 18px",
  icon = null,
}) {
  return (
    <button
      style={{ fontSize, width, padding }}
      className={classes["custom-btn-outline-light"]}
      onClick={onClick}
      disabled={disabled}
    >
      {icon === "cancel" && (
        <i className={classes["icon"]}>
          <X size={16} />
        </i>
      )}
      {text}
    </button>
  );
}

export function CustomButton({
  text,
  onClick,
  fontSize = "14px",
  disabled = false,
  width = "fit-content",
  padding = "4px 18px",
  gap = "4px",
  icon = null,
}) {
  return (
    <button
      style={{ fontSize, width, padding, gap }}
      className={classes["custom-btn"]}
      onClick={onClick}
      disabled={disabled}
    >
      {icon === "refresh" && (
        <i className={classes["icon"]}>
          <RefreshCw size={16} />
        </i>
      )}
      {icon === "tick" && (
        <i className={classes["icon"]}>
          <Check size={16} />
        </i>
      )}
      {icon === "download" && (
        <i className={classes["icon"]}>
          <Download size={16} />
        </i>
      )}
      {text}
    </button>
  );
}

export function CustomButtonWhite({
  text,
  onClick,
  fontSize = "14px",
  fontWeight = "600",
  disabled = false,
  width = "fit-content",
  padding = "4px 18px",
  icon = null,
}) {
  return (
    <button
      style={{ fontSize, width, padding, fontWeight }}
      className={classes["custom-btn-white"]}
      onClick={onClick}
      disabled={disabled}
    >
      {icon === "refresh" && (
        <i className={classes["icon"]}>
          <RefreshCw size={16} />
        </i>
      )}
      {icon === "tick" && (
        <i className={classes["icon"]}>
          <Check size={16} />
        </i>
      )}
      {text}
    </button>
  );
}

export function CustomButtonOutline({
  text,
  onClick,
  fontSize = "14px",
  disabled = false,
  width = "fit-content",
  padding = "4px 18px",
  fontWeight = "600",
}) {
  return (
    <button
      style={{ fontSize, width, padding, fontWeight }}
      className={classes["custom-btn-outline"]}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
}

export function CustomButtonDanger({
  text,
  onClick,
  fontSize = "14px",
  disabled = false,
  width = "fit-content",
  padding = "4px 18px",
}) {
  return (
    <button
      style={{ fontSize, width, padding }}
      className={classes["custom-btn-danger"]}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
}

export function ToggleSwitch({ value, onChange }) {
  return (
    <button
      type="button"
      aria-pressed={value}
      className={classes["toggle-switch"]}
      onClick={() => onChange(!value)}
    >
      <span className={classes["toggle-knob"]}>
        {!value ? <Sun size={12} /> : <Moon size={12} />}
      </span>
    </button>
  );
}
